import React from "react";
import Helmet from "react-helmet";
import Footer from "../components/Footer";
import Header from "../components/Header";
import config from "../../data/SiteConfig";
import * as styles from "./index.module.scss";
import Categories from "../components/Categories";
import WhatsappIcon from "../components/WhatsappIcon";
const MainLayout = ({ children }) => (
  <>
    <Header />
    <Categories />
    <Helmet>
      <meta name='description' content={config.siteDescription} />
    </Helmet>
    {children}
    {/* <WhatsappIcon /> */}
    <Footer />
  </>
);

export default MainLayout;
